import React from "react";
import { Tab } from "../../components/Tab";
import { MachineTranslateText } from "./MachineTranslateText";
import { ManualTranslationRequestText } from "./ManualTranslationRequestText";
import { CustomRequestText } from "./CustomRequestText";

export const TranslateText: React.FC = () => {
  const panes = [
    {
      menuItem: {
        key: "machine",
        icon: <i className="material-icons">memory</i>,
        heading: "Machine Translate",
      },
      content: <MachineTranslateText />,
    },
    {
      menuItem: {
        key: "manual",
        icon: <i className="material-icons">people</i>,
        heading: "Manual Translation",
      },
      content: <ManualTranslationRequestText />,
    },
    {
      menuItem: {
        key: "custom",
        icon: <i className="material-icons">assistant</i>,
        heading: "Custom Request",
      },
      content: <CustomRequestText />,
    },
  ];

  return <Tab panes={panes} data-testid="translate-text-container" />;
};
